import axios from 'axios'
import * as jose from 'jose';
import { LOADING } from '../constants';



/**
 *  Makes a request to login a user
 * @param {string} email - Email of the user.
 * @param {string} password - Password hashed already
*/
export const loginUser = (email, password) => async dispatch => {
    const postObj = {email:email, password:password};
    const request = await axios.post(import.meta.env.VITE_APP_API_URL+'/researchers/login', postObj)
        .catch(err => console.error('Login request failed', err?.response?.status ?? err?.message));

    //Guardamos el token si la request fue exitosa
    if(request.status === 200){
        localStorage.setItem("jwt", request.data.token);
        const payload = jose.decodeJwt(localStorage.getItem("jwt"));
        localStorage.setItem("keyResearcher", payload.keyResearcher);
    }
}



// /**
//  *  Fetches an investigation
//  * @param {string} uuidInvestigation - uuidInvestigation
// */
// export const fetchInvestigation = (uuidInvestigation) => async dispatch => {
    
//     const request = await axios.get(import.meta.env.VITE_APP_API_URL+'/'+localStorage.getItem('type')+'/investigation/'+uuidInvestigation)
       
    
//     dispatch({
//         type : FETCH_INVESTIGATION,
//         payload : request,
//         meta: uuidInvestigation
//     });
// }

/**
 * Changes the state of Loading, that hides or shows the loading screen
 */
export const toggleLoading = ()  => dispatch => {
    
    dispatch({
        type : LOADING
    });
}
